import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { PROJECT_FILES_QUERY } from './useProjectFiles';

const UPDATE_PROJECT_FILE_MUTATION = gql`
  mutation UpdateProjectFile(
    $id: ID!
    $name: String
    $description: String
    $folder: String
    $version: String
    $visibility: ProjectFileVisibilityEnum
  ) {
    updateProjectFile(
      id: $id
      name: $name
      description: $description
      folder: $folder
      version: $version
      visibility: $visibility
    ) {
      projectFile {
        id
        name
        visibility
      }
    }
  }
`;

export interface UpdateProjectFileInput {
  id: string;
  name?: string;
  description?: string;
  folder?: string;
  version?: string;
  visibility?: string;
}

export function useUpdateProjectFile(projectId: string) {
  const [updateMutation, { loading, error }] = useMutation(UPDATE_PROJECT_FILE_MUTATION, {
    refetchQueries: [{ query: PROJECT_FILES_QUERY, variables: { projectId } }],
  });

  const updateProjectFile = async (input: UpdateProjectFileInput) => {
    const { data } = await updateMutation({
      variables: {
        id: input.id,
        name: input.name ?? undefined,
        description: input.description ?? undefined,
        folder: input.folder ?? undefined,
        version: input.version ?? undefined,
        visibility: input.visibility ?? undefined,
      },
    });
    return (data as { updateProjectFile: { projectFile: { id: string; name: string; visibility?: string } } }).updateProjectFile.projectFile;
  };

  return { updateProjectFile, loading, error };
}
